//  获取设备参数
// 国内字典返回逻辑 - 机型与字典关系

// xr-richtex/?parentTag=GJSJ&tag=FFALCON-XR-TAURUS1.5-1

// 0.金牛2.0图文返回逻辑
// 当入参的机型为：FFALCON-XR-TAURUS2.0-1
// 返回：
// 眼镜名：https://rayneo.cn/xr-richtex/?parentTag=GJSJ&tag=FFALCON-XR-TAURUS2.0-1
// 图：https://rayneo.cn/xr-richtex/?parentTag=GJSJ&tag=FFALCON-XR-TAURUS2.0-1-P

// 1.金牛1.5图文返回逻辑
// 当入参的机型为：FFALCON-XR-TAURUS-1 / FFALCON-XR-TAURUS-2 /FFALCON-XR-TAURUS-3时
// 返回：
// 眼镜名：https://test.rayneo.cn/xr-richtex/?parentTag=GJSJ&tag=FFALCON-XR-TAURUS1.5-1
// 图：https://test.rayneo.cn/xr-richtex/?parentTag=GJSJ&tag=FFALCON-XR-TAURUS1.5-1-P

// 2.金牛1.0图文返回逻辑
// 当入参的机型为：FFALCON-XR-ARIES  & packageName为taurus时
// 返回：
// 眼镜名：https://test.rayneo.cn/xr-richtex/?parentTag=GJSJ&tag=FFALCON-XR-TAURUS-1
// 图：https://test.rayneo.cn/xr-richtex/?parentTag=GJSJ&tag=FFALCON-XR-TAURUS-1-P

// 3.白羊1.5图文返回逻辑
// 当入参的机型为FFALCON-XR-ARIES & packageName为aries1p5
// 眼镜名：https://test.rayneo.cn/xr-richtex/?parentTag=GJSJ&tag=FFALCON-XR-ARIES
// 图：https://test.rayneo.cn/xr-richtex/?parentTag=GJSJ&tag=FFALCON-XR-ARIES-P

// 4.白羊1.8图文返回逻辑
// 当入参的机型：FFALCON-XR-ARIES & packageName为aries1p8时，
// 返回：
// 眼镜名：https://test.rayneo.cn/xr-richtex/?parentTag=GJSJ&tag=FFALCON-XR-ARIES1.8
// 图：https://test.rayneo.cn/xr-richtex/?parentTag=GJSJ&tag=FFALCON-XR-ARIES1.8-P

export function getDeviceParam (cu) {
  return {
    aries: {
      //白羊1.0
      clientType: "FFALCON-XR-ARIES",
      packageName: "aries",
      deviceType: "FFALCON-XR-ARIES",
    },
    aries1p5: {
      //白羊1.5
      clientType: "FFALCON-XR-ARIES",
      packageName: "aries1p5",
      deviceType: "FFALCON-XR-ARIES",
    },
    aries1p8: {
      //白羊1.8
      clientType: "FFALCON-XR-ARIES",
      packageName: "aries1p8",
      deviceType: "FFALCON-XR-ARIES1.8",
    },
    taurus: {
      //金牛1.0
      clientType: "FFALCON-XR-ARIES",
      packageName: "taurus",
      deviceType: "FFALCON-XR-TAURUS-1",
    },
    taurus1p5: {
      //金牛1.5
      // 后续需要加 cu
      clientType: `FFALCON-XR-TAURUS-${cu}`,
      packageName: "taurus1p5",
      deviceType: "FFALCON-XR-TAURUS1.5-1",
    },
    taurus2p0: {
      //金牛2.0
      // 后续需要加 cu
      clientType: `FFALCON-XR-TAURUS2.0-${cu}`,
      packageName: "taurus2p0",
      deviceType: "FFALCON-XR-TAURUS2.0-1",
    },
    taurus3p0: {
      //金牛3.0
      // 后续需要加 cu
      clientType: `FFALCON-XR-TAURUS3.0-${cu}`,
      packageName: "taurus3p0",
      deviceType: "FFALCON-XR-TAURUS3.0-1",
    },
    taurus3p0pro: {
      //金牛3.0pro
      // 后续需要加 cu
      clientType: `FFALCON-XR-TAURUS3.0pro-${cu}`,
      packageName: "taurus3p0pro",
      deviceType: "FFALCON-XR-TAURUS3.0pro-1",
    },
    taurus4p0: {
      //金牛4.0
      // 后续需要加 cu
      clientType: `FFALCON-XR-TAURUS4.0-${cu}`,
      packageName: "taurus4p0",
      deviceType: "FFALCON-XR-TAURUS4.0-1",
    },
    taurus4p0pro: {
      //金牛4.0pro
      // 后续需要加 cu
      clientType: `FFALCON-XR-TAURUS4.0pro-${cu}`,
      packageName: "taurus4p0",
      deviceType: "FFALCON-XR-TAURUS4.0pro-1",
    },
    arieslx: {
      clientType: "",
      packageName: "",
      deviceType: "",
    },
    Gemini1p0:{
      clientType:"FFALCON-XR-GEMINIGT-1",
      packageName:"gemini",
      deviceType:"FFALCON-XR-GEMINIGT-1"
    },
    Gemini2p0:{
      clientType:"FFALCON-XR-GEMINIGT-1",
      packageName:"gemini",
      deviceType:"FFALCON-XR-GEMINIGT-1"
    }
    
  };
}

// 传输控制请求 通常用于发送命令和配置设备。
export function requestOut (
  selectedDevice,
  interfaceNumber,
  bRequest,
  data,
  wValue = 0
) {
  return selectedDevice
    .controlTransferOut(
      {
        requestType: "class",
        recipient: "interface",
        request: bRequest,
        value: wValue,
        index: interfaceNumber,
      },
      data
    )
    .then(
      (result) => {
        if (result.status == "ok") {
          return Promise.resolve(result.bytesWritten);
        } else {
          return Promise.reject(result.status);
        }
      },
      (error) => {
        return Promise.reject("ControlTransferOut failed: " + error);
      }
    );
}

// 接收控制请求 通常用于获取设备状态、配置设备或读取设备信息。
export function requestIn (
  selectedDevice,
  interfaceNumber,
  bRequest,
  wLength,
  wValue = 0
) {
  return selectedDevice
    .controlTransferIn(
      {
        requestType: "class",
        recipient: "interface",
        request: bRequest,
        value: wValue,
        index: interfaceNumber,
      },
      wLength
    )
    .then(
      (result) => {
        if (result.status == "ok") {
          return Promise.resolve(result.data);
        } else {
          return Promise.reject(result.status);
        }
      },
      (error) => {
        return Promise.reject("ControlTransferIn failed: " + error);
      }
    );
}

const USB_GET_DESCRIPTOR = 0x06;
const USB_DT_CONFIGURATION = 0x02;
const USB_DT_STRING = 0x03;
const USB_DT_INTERFACE = 4;
const USB_DT_DFU_FUNCTIONAL = 0x21;

async function controlTransferInOk (device, setup, length) {
  const result = await device.controlTransferIn(setup, length);
  if (result.status !== "ok") {
    throw new Error(String(result.status));
  }
  return result;
}

/**
 * 标准 GET_DESCRIPTOR 读取完整 Configuration 描述符（先 4 字节取 wTotalLength 再读全量）。
 * @param {USBDevice} device
 * @param {number} configIndex 配置索引（与 WebUSB getDevices 中 configurations 下标一致）
 * @returns {Promise<DataView>}
 */
export async function readDeviceConfigurationDescriptor (device, configIndex) {
  const wValue = (USB_DT_CONFIGURATION << 8) | configIndex;
  const setup = {
    requestType: "standard",
    recipient: "device",
    request: USB_GET_DESCRIPTOR,
    value: wValue,
    index: 0,
  };
  const first = await controlTransferInOk(device, setup, 4);
  const wLength = first.data.getUint16(2, true);
  const full = await controlTransferInOk(device, setup, wLength);
  return full.data;
}

/**
 * 读 configuration index 0，在 bConfigurationValue 与 settings.configuration 一致时解析 DFU Functional Descriptor (0x21)。
 * 需设备已授权且可执行标准 GET_DESCRIPTOR（通常已 open）。
 * @param {USBDevice} selectedDevice
 * @param {{ configuration: { configurationValue: number } }} settings WebUSB settings 对象（与 getCurrentDeiceType 一致）
 * @returns {Promise<Record<string, never> | { WillDetach: boolean, ManifestationTolerant: boolean, CanUpload: boolean, CanDnload: boolean, TransferSize: number, DetachTimeOut: number, DFUVersion: number }>}
 */
export async function getDFUDescriptorProperties (selectedDevice, settings) {
  try {
    if (!selectedDevice || !settings || !settings.configuration) {
      return {};
    }
    const configValue = settings.configuration.configurationValue;
    const data = await readDeviceConfigurationDescriptor(selectedDevice, 0);
    const bConfigurationValue = data.getUint8(5);
    if (bConfigurationValue !== configValue) {
      return {};
    }
    const wTotalLength = data.getUint16(2, true);
    let offset = 9;
    while (offset + 2 <= wTotalLength && offset + 2 <= data.byteLength) {
      const bLength = data.getUint8(offset);
      if (bLength < 2) {
        break;
      }
      const bDescriptorType = data.getUint8(offset + 1);
      if (bDescriptorType === USB_DT_DFU_FUNCTIONAL && bLength >= 9) {
        const bmAttributes = data.getUint8(offset + 2);
        const wDetachTimeOut = data.getUint16(offset + 3, true);
        const wTransferSize = data.getUint16(offset + 5, true);
        const bcdDFUVersion = data.getUint16(offset + 7, true);
        return {
          WillDetach: (bmAttributes & 0x08) !== 0,
          ManifestationTolerant: (bmAttributes & 0x04) !== 0,
          CanUpload: (bmAttributes & 0x02) !== 0,
          CanDnload: (bmAttributes & 0x01) !== 0,
          TransferSize: wTransferSize,
          DetachTimeOut: wDetachTimeOut,
          DFUVersion: bcdDFUVersion,
        };
      }
      offset += bLength;
    }
    return {};
  } catch (e) {
    console.warn("[webusb] getDFUDescriptorProperties", e);
    return {};
  }
}

/**
 * 标准 GET_DESCRIPTOR 读取 String 描述符（先 1 字节取 bLength 再读全量）。
 * @param {USBDevice} device
 * @param {number} stringIndex
 * @param {number} langID 0 表示读语言 ID 列表；非 0 时返回 UCS-2 解码后的字符串
 */
export async function readDeviceStringDescriptor (device, stringIndex, langID) {
  const wValue = (USB_DT_STRING << 8) | stringIndex;
  const setup = {
    requestType: "standard",
    recipient: "device",
    request: USB_GET_DESCRIPTOR,
    value: wValue,
    index: langID,
  };
  const head = await controlTransferInOk(device, setup, 1);
  const bLength = head.data.getUint8(0);
  const full = await controlTransferInOk(device, setup, bLength);
  const len = (bLength - 2) / 2;
  const u16Words = [];
  for (let i = 0; i < len; i++) {
    u16Words.push(full.data.getUint16(2 + i * 2, true));
  }
  if (langID === 0) {
    return u16Words;
  }
  return String.fromCharCode.apply(String, u16Words);
}

const DEFAULT_INTERFACE_NAME_LANG_ID = 0x0409;

/**
 * 构建 mapping[bConfigurationValue][bInterfaceNumber][bAlternateSetting] = 接口名称字符串
 * @param {USBDevice} device
 * @param {number} [stringLangId=0x0409]
 */
export async function readInterfaceNamesMapping (
  device,
  stringLangId = DEFAULT_INTERFACE_NAME_LANG_ID
) {
  const configs = {};
  const allStringIndices = new Set();
  for (
    let configIndex = 0;
    configIndex < device.configurations.length;
    configIndex++
  ) {
    const raw = await readDeviceConfigurationDescriptor(device, configIndex);
    const bConfigurationValue = raw.getUint8(5);
    configs[bConfigurationValue] = {};
    const wTotalLength = raw.getUint16(2, true);
    let offset = 9;
    while (offset + 2 <= wTotalLength && offset + 2 <= raw.byteLength) {
      const bLength = raw.getUint8(offset);
      if (bLength < 2) {
        break;
      }
      const bDescriptorType = raw.getUint8(offset + 1);
      if (bDescriptorType === USB_DT_INTERFACE && bLength >= 9) {
        const bInterfaceNumber = raw.getUint8(offset + 2);
        const bAlternateSetting = raw.getUint8(offset + 3);
        const iInterface = raw.getUint8(offset + 8);
        if (!(bInterfaceNumber in configs[bConfigurationValue])) {
          configs[bConfigurationValue][bInterfaceNumber] = {};
        }
        configs[bConfigurationValue][bInterfaceNumber][bAlternateSetting] =
          iInterface;
        if (iInterface > 0) {
          allStringIndices.add(iInterface);
        }
      }
      offset += bLength;
    }
  }

  const strings = {};
  for (const index of allStringIndices) {
    try {
      strings[index] = await readDeviceStringDescriptor(
        device,
        index,
        stringLangId
      );
    } catch (error) {
      console.log(error);
      strings[index] = null;
    }
  }

  for (const cv of Object.keys(configs)) {
    for (const intfNum of Object.keys(configs[cv])) {
      for (const alt of Object.keys(configs[cv][intfNum])) {
        const iIdx = configs[cv][intfNum][alt];
        configs[cv][intfNum][alt] = strings[iIdx];
      }
    }
  }
  return configs;
}

/**
 * 释放当前 configuration 下所有已 claim 的接口。
 * @param {USBDevice} usbDevice
 */
export async function releaseAllClaimedUsbInterfaces (usbDevice) {
  if (!usbDevice || !usbDevice.opened || !usbDevice.configuration) {
    return;
  }
  for (const iface of usbDevice.configuration.interfaces) {
    if (iface.claimed) {
      try {
        await usbDevice.releaseInterface(iface.interfaceNumber);
      } catch (e) {
        console.warn("[webusb] releaseInterface", iface.interfaceNumber, e);
      }
    }
  }
}

/**
 * 释放 claim 并 close，便于换 DFU 接口 / alternate 或 ZIP 多子任务间重开会话（与 dfu-util 行为对齐）。
 * @param {USBDevice} usbDevice
 */
export async function resetUsbSessionForDfuSwitch (usbDevice) {
  if (!usbDevice) {
    return;
  }
  try {
    if (usbDevice.opened) {
      await releaseAllClaimedUsbInterfaces(usbDevice);
      await usbDevice.close();
    }
  } catch (e) {
    console.warn("[webusb] resetUsbSessionForDfuSwitch", e);
  }
}

/**
 * 会话丢失 / 刷新页面后 DFU 可能停在 DNLOAD 等状态且控制端点 STALL。
 * 在 Rayneo 自定义 UPLOAD（0x02）版本探测前调用：ABORT + CLRSTATUS + GET_STATUS，尽量回到 dfuIDLE。
 * @param {USBDevice} rawDevice 已 open 且已 claim 对应 DFU interface
 * @param {number} interfaceNumber DFU interface 号
 */
export async function recoverRayneoDfuControlForVersionProbe (
  rawDevice,
  interfaceNumber
) {
  const DFU_ABORT = 0x06;
  const DFU_CLRSTATUS = 0x04;
  const DFU_GETSTATUS = 0x03;
  const DFU_IDLE = 2;

  const setup = (request, value = 0) => ({
    requestType: "class",
    recipient: "interface",
    request,
    value,
    index: interfaceNumber,
  });

  const transferOut = async (request, value = 0) => {
    try {
      await rawDevice.controlTransferOut(
        setup(request, value),
        new ArrayBuffer(0)
      );
    } catch (e) {
      console.debug("[webusb] recoverRayneoDfu OUT", request, e);
    }
  };

  await transferOut(DFU_ABORT);
  await transferOut(DFU_ABORT);
  await transferOut(DFU_CLRSTATUS);

  const maxRounds = 12;
  for (let i = 0; i < maxRounds; i++) {
    let st;
    try {
      st = await rawDevice.controlTransferIn(setup(DFU_GETSTATUS), 6);
    } catch (e) {
      console.debug("[webusb] recoverRayneoDfu GET_STATUS", e);
      await transferOut(DFU_CLRSTATUS);
      continue;
    }

    if (st.status === "stall") {
      await transferOut(DFU_CLRSTATUS);
      continue;
    }
    if (st.status !== "ok" || !st.data || st.data.byteLength < 6) {
      await transferOut(DFU_CLRSTATUS);
      continue;
    }

    const statusByte = st.data.getUint8(0);
    const state = st.data.getUint8(4);
    const pollMs = st.data.getUint32(1, true) & 0xffffff;

    if (state === DFU_IDLE && statusByte === 0) {
      return;
    }

    await transferOut(DFU_ABORT);
    await transferOut(DFU_CLRSTATUS);

    if (pollMs > 0 && pollMs < 5000) {
      await new Promise((r) => setTimeout(r, pollMs));
    }
  }
}
